<template>
  <v-app>
    <v-main class="fondo">
      <transition name="component-fade" mode="out-in" appear>
        <router-view :urlApi="urlApi" />
      </transition>
    </v-main>
  </v-app>
</template>

<script>
export default {
  name: "App",

  data: () => ({
    // urlApi: "https://netcore.ucm.cl/feature/API-APP/",
    urlApi: "https://arce.ucm.cl/prod/alumni-credencial/",
  }),

  methods: {},
};
</script>

<style>
.fondo {
  font-family: "Montserrat", sans-serif;
  background: #000046; /* fallback for old browsers */
  background: -webkit-linear-gradient(
    to right,
    #1cb5e0,
    #000046
  ); /* Chrome 10-25, Safari 5.1-6 */
  background: linear-gradient(
    to right,
    #1cb5e0,
    #000046
  ); /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
}

.component-fade-enter-active,
.component-fade-leave-active {
  transition: opacity 0.3s ease;
}
.component-fade-enter, .component-fade-leave-to
/* .component-fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
